import { useFrame } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import Earth from "../../Earth.js";

//react component
export default function Experience({ scale = 1 }) {

  //will be called on each frame
  useFrame((state, delta) => {});

  return (
    <>
      <OrbitControls makeDefault />
      <Earth scale={2} />
    </>
  );
}
